import { JSX, FC, useEffect, Dispatch, SetStateAction } from "react";
import FilterWrapper from "components/ui/Filters/FiltersDrawer/FilterWrapper";
import { Form, TreeSelect } from "antd";

import { OptionType } from "utils/formatCategories";
import { ProductsFiltersValuesType } from "app/types";
import { DefaultOptionType } from "antd/es/select";

interface IProductsCategoryFiltersProps {
  values: ProductsFiltersValuesType;
  categoriesTree: OptionType[];
  categoriesTPTree: OptionType[];
  setSelectedCategories: Dispatch<SetStateAction<number[]>>;
  setSelectedCategoriesTP: Dispatch<SetStateAction<number[]>>;
}

const ProductsCategoryFilters: FC<IProductsCategoryFiltersProps> = ({
  values,
  categoriesTree,
  categoriesTPTree,
  setSelectedCategories,
  setSelectedCategoriesTP,
}): JSX.Element => {
  useEffect(() => {
    setSelectedCategories(values?.supplierCategory?.map(({ value }) => value as number));
  }, [values?.supplierCategory]);

  useEffect(() => {
    setSelectedCategoriesTP(values?.categoryBK?.map(({ value }) => value as number));
  }, [values?.categoryBK]);

  const renderTreeSelect = (treeData: OptionType[]): JSX.Element => (
    <TreeSelect
      multiple
      size="large"
      showSearch
      placeholder="Выберите категорию"
      allowClear
      virtual={false}
      labelInValue
      treeData={treeData}
      treeDefaultExpandAll
      fieldNames={{ label: "label", value: "value", children: "children" }}
      filterTreeNode={(input: string, option: DefaultOptionType) =>
        option.label?.toString()?.toLowerCase()?.includes(input.toLowerCase())
      }
    />
  );

  return (
    <>
      <FilterWrapper label="По категории">
        <Form.Item className="m-0" name="supplierCategory" initialValue={[]}>
          {renderTreeSelect(categoriesTree)}
        </Form.Item>
      </FilterWrapper>
      <FilterWrapper label="По категории БК">
        <Form.Item className="m-0" name="categoryBK" initialValue={[]}>
          {renderTreeSelect(categoriesTPTree)}
        </Form.Item>
      </FilterWrapper>
    </>
  );
};

export default ProductsCategoryFilters;
